<footer>
  <div class="container-sm">
    <img class="pl-logo" [src]="PotImages.potentialifeLogo" alt="Scroll to top" (click)="goToLink('/')" />
    @for (item of footerMenuItems; track item) {
      <div class="footer-menu-item" (click)="goToLink(item.link)">
        <p>{{ item.title }}</p>
      </div>
    }
  </div>
</footer>
